import * as React from 'react'
import { connect } from 'react-redux'
import * as events from '../../../events'
import { Colors, StackChildren, Text, Inline } from '@doordash/design-language'
import Button from '@doordash/component-button'
import Tag from '@doordash/component-tag'
import { ssnCheckStatus } from './strings'
import { SSNStatus } from '../../../models/types'
import { StepButtonContainer } from './styles'
import {
  BACKGROUND_CHECK_HELP_URL,
  CheckrStatusResults,
  SSN_CHECK_HELP_URL,
} from '../../../constants'

type SSNCheckStepProps = {
  trackConfirmationPageClick?: (name: string, data?: object) => Promise<void>
  generateTitle: Function
  ssnStatus: SSNStatus
  backgroundCheckResults: CheckrStatusResults
  isActive: boolean
}
const statusProps = {
  [SSNStatus.Declined]: {
    href: SSN_CHECK_HELP_URL,
    ctaText: ssnCheckStatus.declined.action(),
    tagType: Tag.Types.WarningEmphasis,
    btnType: Button.Types.TertiaryPill,
  },
  [SSNStatus.NeedsReview]: {
    href: BACKGROUND_CHECK_HELP_URL,
    ctaText: ssnCheckStatus.needs_review.action(),
    tagType: Tag.Types.InformationalDefault,
    btnType: Button.Types.PrimaryPill,
  },
  [SSNStatus.Approved]: {
    tagType: Tag.Types.HighlightDefault,
    href: null,
    ctaText: null,
    btnType: Button.Types.PrimaryPill,
  },
}
const SSNCheckStep: React.SFC<SSNCheckStepProps> = ({
  ssnStatus,
  backgroundCheckResults,
  trackConfirmationPageClick,
  isActive,
}) => {
  const shouldShowCTA =
    ssnStatus === SSNStatus.Declined || ssnStatus === SSNStatus.NeedsReview
  const showStatus =
    ssnStatus === SSNStatus.Approved &&
    backgroundCheckResults === CheckrStatusResults.Clear
  return (
    <StackChildren size={StackChildren.Sizes.XxSmall}>
      {(isActive || showStatus) && (
        <>
          <>
            <Tag
              size={Tag.Sizes.Medium}
              text={ssnCheckStatus[ssnStatus].label()}
              type={statusProps[ssnStatus].tagType}
            />
            <Text color={Colors.SystemGrey80}>
              {ssnCheckStatus[ssnStatus].description()}
            </Text>
            {ssnStatus === SSNStatus.NeedsReview && (
              <Text color={Colors.SystemGrey80}>
                {ssnCheckStatus[ssnStatus].description2()}
              </Text>
            )}
          </>
          <StepButtonContainer>
            <div>
              {shouldShowCTA && (
                <Inline size={Inline.Sizes.XxSmall}>
                  <Button
                    type={statusProps[ssnStatus].btnType}
                    isInline
                    size={Button.Sizes.Small}
                    href={statusProps[ssnStatus].href}
                    tag="a"
                    target={'_blank'}
                    onClick={e => {
                      trackConfirmationPageClick('ssn_check_status_button', {
                        button: statusProps[ssnStatus].ctaText,
                      })
                      e.stopPropagation()
                    }}
                  >
                    {statusProps[ssnStatus].ctaText}
                  </Button>
                </Inline>
              )}
            </div>
          </StepButtonContainer>
        </>
      )}
      {!isActive && (
        <Text color={Colors.SystemGrey60} size={Text.Sizes.S14}>
          {ssnCheckStatus.description()}
        </Text>
      )}
    </StackChildren>
  )
}
const mapDispatchToProps = {
  trackConfirmationPageClick: events.trackConfirmationPageClick,
}

export default connect(null, mapDispatchToProps)(SSNCheckStep)
